import { OhmLogo } from '@ohpen/enso-ui';
import type { AssistantConfig, AssistantContext } from '@ohpen/enso-ui';

import { readAssistantContext } from '@pmp/stores';

import { agentTransport } from './agentTransport';
import { openCreateFormAction } from './crudRegistry';
import { openCloneTableAction } from './cloneRegistry';
import { openFilteredListAction } from './listRegistry';

// Assistant configuration passed to EnsoProvider. Enables the "Ohm" launcher in the
// TopBar and wires the panel to the PMP agent via agentTransport.
export const pmpAssistantConfig: AssistantConfig = {
  transport: agentTransport,
  name: 'Ohm',
  avatar: (state, slot) => <OhmLogo state={state} mono={slot === 'launcher'} size={slot === 'launcher' ? 22 : 20} />,
  systemPrompt: 'You are Ohm, the PMP assistant for the Product Manager Portal.',
  // Read once per turn: ids and metadata only, the agent re-reads the values through its own tools.
  getContext: (): AssistantContext => readAssistantContext(),
  // What the panel asks the user to approve: being taken to a page they do not have open, whether to read a
  // list or to fill in a form.
  actions: [openFilteredListAction, openCreateFormAction, openCloneTableAction],
  content: { mermaid: true },
  ui: { defaultMode: 'docked', launcher: 'topbar' },
  history: { max: 20 },
};
